"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeAuctionAccountIx = exports.closeComboOptionAccountIx = exports.closeOptionAccountIx = exports.updateOracleIx = exports.exerciseOptionIx = exports.expireOptionIx = exports.expireOptionOverrideIx = exports.cancelBidIx = exports.bidAuctionIx = exports.cancelAuctionIx = exports.acceptBidIx = exports.initializeAuctionIx = exports.collectRemainingCollateralIx = exports.burnOptionIx = exports.initializeComboOptionV2Ix = exports.initializeOptionV2Ix = exports.initializeUnderlyingIx = exports.initializeWhitelistFeesAccountIx = exports.updateStateAccountIx = exports.initializeStateIx = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const flex_1 = require("./flex");
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const utils = __importStar(require("./flex-utils"));
const flexTypes = __importStar(require("./types"));
const solendUtils = __importStar(require("../solend/utils"));
const spl_token_2 = require("@solana/spl-token");
async function initializeStateIx(settlementPriceThresholdSeconds, mintOptionFee, feeRecipient, accountCloseThresholdSecs) {
    let [state, _stateNonce] = utils.getStateAddress(flex_1.flex.programId);
    let [mintAuthority, mintAuthNonce] = utils.getMintAuthorityAddress(flex_1.flex.programId);
    let [vaultAuthority, vaultAuthNonce] = utils.getVaultAuthorityAddress(flex_1.flex.programId);
    let args = {
        mintAuthNonce,
        vaultAuthNonce,
        settlementPriceThresholdSeconds,
        mintOptionFee,
        feeRecipient,
        accountCloseThresholdSecs,
    };
    return flex_1.flex.program.methods
        .initializeState(args)
        .accounts({
        state,
        systemProgram: web3_js_1.SystemProgram.programId,
        admin: flex_1.flex.provider.wallet.publicKey,
        mintAuthority,
        vaultAuthority,
    })
        .instruction();
}
exports.initializeStateIx = initializeStateIx;
async function updateStateAccountIx(args) {
    return flex_1.flex.program.methods
        .updateStateAccount(args)
        .accounts({
        state: flex_1.flex.stateAddress,
        admin: flex_1.flex.provider.wallet.publicKey,
    })
        .instruction();
}
exports.updateStateAccountIx = updateStateAccountIx;
async function initializeWhitelistFeesAccountIx(user, whitelistFeesAccount) {
    return await flex_1.flex.program.methods
        .intializeWhitelistFeesAccount()
        .accounts({
        state: flex_1.flex.stateAddress,
        whitelistFeesAccount,
        admin: flex_1.flex.provider.wallet.publicKey,
        user,
        systemProgram: web3_js_1.SystemProgram.programId,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .instruction();
}
exports.initializeWhitelistFeesAccountIx = initializeWhitelistFeesAccountIx;
async function initializeUnderlyingIx(underlyingMint, oracle, underlyingType) {
    let [underlying, _underlyingNonce] = utils.getUnderlyingAddress(flex_1.flex.program.programId, underlyingMint);
    let args = {
        underlyingType: flexTypes.toProgramUnderlyingType(underlyingType),
    };
    return flex_1.flex.program.methods
        .initializeUnderlying(args)
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying,
        mint: underlyingMint,
        oracle: oracle,
        admin: flex_1.flex.provider.wallet.publicKey,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .instruction();
}
exports.initializeUnderlyingIx = initializeUnderlyingIx;
async function initializeOptionV2Ix(initOptionArgs, underlying, vault, collateralMint, collateralTokenAccount, userKey, optionAccount, optionMint, userOptionTokenAccount, feeRecipientCollateralTokenAccount, optionMintMetadataAccount, remainingAccounts) {
    return flex_1.flex.program.methods
        .initializeOptionV2(initOptionArgs)
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        collateralMint,
        collateralTokenAccount,
        feeRecipientCollateralTokenAccount,
        creator: userKey,
        mintAuthority: flex_1.flex.mintAuthorityAddress,
        optionAccount,
        optionMint,
        userOptionTokenAccount,
        vault,
        optionMintMetadataAccount,
        flexProgram: flex_1.flex.programId,
        mplTokenMetadataProgram: mpl_token_metadata_1.PROGRAM_ID,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: spl_token_2.ASSOCIATED_TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.initializeOptionV2Ix = initializeOptionV2Ix;
async function initializeComboOptionV2Ix(initComboOptionArgs, underlying, vault, collateralMint, collateralTokenAccount, userKey, comboOptionAccount, optionMint, userOptionTokenAccount, feeRecipientCollateralTokenAccount, optionMintMetadataAccount, remainingAccounts) {
    return flex_1.flex.program.methods
        .initializeComboOptionV2(initComboOptionArgs)
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        collateralMint,
        collateralTokenAccount,
        feeRecipientCollateralTokenAccount,
        creator: userKey,
        mintAuthority: flex_1.flex.mintAuthorityAddress,
        optionAccount: comboOptionAccount,
        optionMint,
        userOptionTokenAccount,
        vault,
        optionMintMetadataAccount,
        flexProgram: flex_1.flex.programId,
        mplTokenMetadataProgram: mpl_token_metadata_1.PROGRAM_ID,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: spl_token_2.ASSOCIATED_TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.initializeComboOptionV2Ix = initializeComboOptionV2Ix;
async function burnOptionIx(burnAmount, optionInfo, userCollateralTokenAccount, userOptionTokenAccount, userKey) {
    return flex_1.flex.program.methods
        .burnOption(burnAmount)
        .accounts({
        state: flex_1.flex.stateAddress,
        vault: optionInfo.vault,
        collateralMint: optionInfo.collateralMint,
        collateralTokenAccount: userCollateralTokenAccount,
        creator: userKey,
        optionAccount: optionInfo.optionAccount,
        mintAuthority: flex_1.flex.mintAuthorityAddress,
        optionMint: optionInfo.optionMint,
        userOptionTokenAccount: userOptionTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
    })
        .instruction();
}
exports.burnOptionIx = burnOptionIx;
async function collectRemainingCollateralIx(optionInfo, userCollateralTokenAccount, userOptionTokenAccount, userKey) {
    return flex_1.flex.program.methods
        .collectRemainingCollateral()
        .accounts({
        state: flex_1.flex.stateAddress,
        vault: optionInfo.vault,
        collateralTokenAccount: userCollateralTokenAccount,
        creator: userKey,
        optionAccount: optionInfo.optionAccount,
        optionMint: optionInfo.optionMint,
        userOptionTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
    })
        .instruction();
}
exports.collectRemainingCollateralIx = collectRemainingCollateralIx;
async function initializeAuctionIx(initAuctionArgs, auctionAccount, userKey, auctionVault, auctionTokenMint, userAuctionTokenAccount, bidCurrencyMint) {
    return flex_1.flex.program.methods
        .initializeAuction(initAuctionArgs)
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount,
        creator: userKey,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        auctionVault,
        auctionTokenMint,
        creatorAuctionTokenAccount: userAuctionTokenAccount,
        bidCurrencyMint: bidCurrencyMint,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .instruction();
}
exports.initializeAuctionIx = initializeAuctionIx;
async function acceptBidIx(userKey, bidAccountInfo, auctionAccountInfo, bidderAuctionTokenAccount, creatorBidCurrencyTokenAccount) {
    return flex_1.flex.program.methods
        .acceptBid(new anchor.BN(bidAccountInfo.amount))
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount: auctionAccountInfo.address,
        bidder: bidAccountInfo.bidder,
        creator: userKey,
        bidAccount: bidAccountInfo.address,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        bidVault: bidAccountInfo.bidVault,
        auctionVault: auctionAccountInfo.auctionVault,
        bidderAuctionTokenAccount,
        creatorBidCurrencyTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .instruction();
}
exports.acceptBidIx = acceptBidIx;
async function cancelAuctionIx(userKey, auctionAccountInfo, userAuctionTokenAccount) {
    return flex_1.flex.program.methods
        .cancelAuction()
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount: auctionAccountInfo.address,
        creator: userKey,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        auctionVault: auctionAccountInfo.auctionVault,
        creatorAuctionTokenAccount: userAuctionTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .instruction();
}
exports.cancelAuctionIx = cancelAuctionIx;
async function bidAuctionIx(auctionAccount, bidAccount, bidVault, bidder, bidCurrencyMint, bidderBidCurrencyTokenAccount, amount) {
    let args = {
        amount: new anchor.BN(amount),
    };
    return flex_1.flex.program.methods
        .bidAuction(args)
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount,
        bidder,
        bidAccount,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        bidVault,
        bidCurrencyMint,
        bidderBidCurrencyTokenAccount,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .instruction();
}
exports.bidAuctionIx = bidAuctionIx;
async function cancelBidIx(auctionAccount, bidder, bidAccount, bidVault, bidderBidCurrencyTokenAccount) {
    return flex_1.flex.program.methods
        .cancelBid()
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount,
        bidder,
        bidAccount,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        bidVault,
        bidderBidCurrencyTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .instruction();
}
exports.cancelBidIx = cancelBidIx;
async function expireOptionOverrideIx(overrideSettlementPrice, optionAccount, optionType, admin = undefined) {
    let optionAccountInfo = flex_1.flex.getOption(optionAccount, optionType);
    let underlying = flex_1.flex.getUnderlying(optionAccountInfo.underlyingMint);
    return flex_1.flex.program.methods
        .expireOptionOverride(new anchor.BN(overrideSettlementPrice))
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying: underlying.address,
        collateralMint: optionAccountInfo.collateralMint,
        optionAccount,
        optionMint: optionAccountInfo.optionMint,
        vault: optionAccountInfo.vault,
        admin: admin ? admin : flex_1.flex.provider.wallet.publicKey,
    })
        .instruction();
}
exports.expireOptionOverrideIx = expireOptionOverrideIx;
async function expireOptionIx(optionAccount, optionType) {
    let optionAccountInfo = flex_1.flex.getOption(optionAccount, optionType);
    let underlying = flex_1.flex.getUnderlying(optionAccountInfo.underlyingMint);
    let reserveForExpiry = undefined;
    if (underlying.underlyingType == flexTypes.UnderlyingType.SOLEND_C_TOKEN) {
        reserveForExpiry = solendUtils.getSolendReserveMapping(flex_1.flex.network, underlying.mint);
    }
    else if (optionType == flexTypes.FlexOptionType.Normal &&
        optionAccountInfo.kind == flexTypes.Kind.CTOKENPUT) {
        reserveForExpiry = solendUtils.getSolendReserveMapping(flex_1.flex.network, optionAccountInfo.collateralMint);
    }
    let remainingAccounts = [];
    if (reserveForExpiry != undefined) {
        remainingAccounts.push({
            pubkey: reserveForExpiry,
            isSigner: false,
            isWritable: false,
        });
    }
    let [settlementAccount, _settlementAccountNonce] = utils.getSettlementAddress(flex_1.flex.programId, underlying.address, new anchor.BN(optionAccountInfo.expiry));
    let args = {
        settlementTs: new anchor.BN(optionAccountInfo.expiry),
    };
    return flex_1.flex.program.methods
        .expireOption(args)
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying: underlying.address,
        collateralMint: optionAccountInfo.collateralMint,
        optionAccount,
        oracle: underlying.oracle,
        optionMint: optionAccountInfo.optionMint,
        vault: optionAccountInfo.vault,
        creator: optionAccountInfo.creator,
        payer: flex_1.flex.provider.wallet.publicKey,
        settlementAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        systemProgram: web3_js_1.SystemProgram.programId,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.expireOptionIx = expireOptionIx;
async function exerciseOptionIx(option, userCollateralTokenAccount, userOptionTokenAccount, userKey, remainingAccounts, exerciseAmount) {
    return flex_1.flex.program.methods
        .exerciseOption(exerciseAmount == undefined ? null : new anchor.BN(exerciseAmount))
        .accounts({
        state: flex_1.flex.stateAddress,
        vault: option.vault,
        collateralMint: option.collateralMint,
        collateralTokenAccount: userCollateralTokenAccount,
        authority: userKey,
        optionAccount: option.optionAccount,
        optionMint: option.optionMint,
        userOptionTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        vaultAuthority: flex_1.flex.vaultAuthorityAddress,
        creator: option.creator,
    })
        .remainingAccounts(remainingAccounts)
        .instruction();
}
exports.exerciseOptionIx = exerciseOptionIx;
async function updateOracleIx(underlying, newOracle) {
    return flex_1.flex.program.methods
        .updateOracle()
        .accounts({
        state: flex_1.flex.stateAddress,
        underlying,
        newOracle,
        admin: flex_1.flex.state.admin,
    })
        .instruction();
}
exports.updateOracleIx = updateOracleIx;
async function closeOptionAccountIx(option) {
    return flex_1.flex.program.methods
        .closeOptionAccount()
        .accounts({
        state: flex_1.flex.stateAddress,
        optionAccount: option.optionAccount,
        vault: option.vault,
        admin: flex_1.flex.state.admin,
    })
        .instruction();
}
exports.closeOptionAccountIx = closeOptionAccountIx;
async function closeComboOptionAccountIx(option) {
    return flex_1.flex.program.methods
        .closeComboOptionAccount()
        .accounts({
        state: flex_1.flex.stateAddress,
        comboOptionAccount: option.optionAccount,
        vault: option.vault,
        admin: flex_1.flex.state.admin,
    })
        .instruction();
}
exports.closeComboOptionAccountIx = closeComboOptionAccountIx;
async function closeAuctionAccountIx(auction) {
    return flex_1.flex.program.methods
        .closeAuctionAccount()
        .accounts({
        state: flex_1.flex.stateAddress,
        auctionAccount: auction.address,
        auctionVault: auction.auctionVault,
        creator: auction.creator,
        admin: flex_1.flex.state.admin,
    })
        .instruction();
}
exports.closeAuctionAccountIx = closeAuctionAccountIx;
